import { render, staticRenderFns } from "./BaseSvg.vue?vue&type=template&id=5a1f9dce&"
import script from "./BaseSvg.vue?vue&type=script&lang=js&"
export * from "./BaseSvg.vue?vue&type=script&lang=js&"
import style0 from "./BaseSvg.vue?vue&type=style&index=0&id=5a1f9dce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports